import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base } from '@/store/base/module'
import moment from 'moment'

const module = {
  state: {
    studentSchedule: [],
    t0060_seminar_calendar: [],
    currentScreen: 1,
    selectedDate: moment().format('YYYY-MM-DD'),
    getStudentSchedule_input: {
      student_no: null,
      start_date: null,
      end_date: null,
    }
  },
  getters: {
    isAfterAvailabilityTime: (state) => (date) => {
      const targetDate = moment(date).startOf('day');
      return moment().isAfter(targetDate);
    },
    isSeminarEntryDate (state) {
      return !!state.t0060_seminar_calendar.find(item => moment().startOf('day').isBetween(item.entry_start_date, item.entry_end_date, undefined, '[]'))
    }
  },
  mutations: {
  },
  actions: {
    async C21201_getStudentSchedule({ state, commit }, payload) {
      try {
        const input = payload || state.getStudentSchedule_input

        const response = await ApiUtils.postData({
          data: {
            C21201_getStudentSchedule: {
              api: 'T0050CalendarService.C21201_getStudentSchedule',
              input
            },
            t0060_seminar_calendar: {
              api: 'T0060SeminarCalendarService.getAvailableSeminar'
            },
          }
        })

        commit('setState', {
          studentSchedule: response.C21201_getStudentSchedule.output,
          t0060_seminar_calendar: response.t0060_seminar_calendar.output
        })
      } catch (error) {
        console.error('Failed to fetch student schedule:', error)
        throw error
      }
    },
    async C21201_doAddRequest({ state }, payload) {
      try {
        const response = await ApiUtils.postData({
          data: [
            {
              api: 'T1035StudentRequestService.C21201_doAddRequest',
              input: payload
            }
          ]
        })
        return response
      } catch (error) {
        console.error('Failed to add student request:', error)
        throw error
      }
    },
    async C21201_getRequest({ state }, payload) {
      try {
        const response = await ApiUtils.postData({
          data: [
            {
              api: 'T1035StudentRequestService.getRequest',
              input: payload
            }
          ]
        })
        return response
      } catch (error) {
        console.error('Failed to get student request:', error)
        throw error
      }
    },
    async C21201_saveStudentHandleImage({ state }, payload) {
      try {
        const response = await ApiUtils.postData({
          data: [
            {
              api: 'T1037StudentHandleImageService.C21201_saveStudentHandleImage',
              input: payload
            }
          ]
        })
        return response[0].output
      } catch (error) {
        console.error('Failed to get student handle image:', error)
        throw error
      }
    },
    async C21201_getStudentHandleImage({ state }, payload) {
      try {
        const response = await ApiUtils.postData({
          data: [
            {
              api: 'T1037StudentHandleImageService.C21201_getStudentHandleImage',
              input: payload
            }
          ]
        }, false)
        return response[0].output
      } catch (error) {
        console.error('Failed to get student handle image:', error)
        throw error
      }
    },
  }
}

export default ObjArrUtils.merge(Base, module)
